import styled from 'styled-components'
import Assigned from '../../../static/images/questhistory/assigned.svg'
import Unassigned from '../../../static/images/questhistory/unassigned.svg'
import CommentEdited from '../../../static/images/questhistory/comment_edited.svg'
import CommentPosted from '../../../static/images/questhistory/comment_posted.svg'
import Edit from '../../../static/images/questhistory/edit.svg'
import InternalApproved from '../../../static/images/questhistory/internal_approved.svg'
import InternalRemoved from '../../../static/images/questhistory/internal_removed.svg'
import QualityApproved from '../../../static/images/questhistory/quality_approved.svg'
import QualityRejected from '../../../static/images/questhistory/quality_rejected.svg'
import CreateQuest from '../../../static/images/questhistory/icon_create_quest.svg'
import DraftLabel from '../../../static/images/questhistory/draft_status_label.svg'
import PublishedLabel from '../../../static/images/questhistory/published_status_label.svg'
import ReviewReturnedLabel from '../../../static/images/questhistory/review_returned_status_label.svg'
import InQualityReviewLabel from '../../../static/images/questhistory/in_publication_review_status_label.svg'
import ReviewComment from '../../../static/images/questhistory/review_comment.svg'
import Deleted from '../../../static/images/questhistory/icon_deleted.svg'
import ActivityAdd from '../../../static/images/questhistory/icon_activity_added.svg'
import ActivitiesSorted from '../../../static/images/questhistory/icon_activities_sorted.svg'

const ReviewCommentIcon = styled.div`
  background: url(${ReviewComment}) no-repeat;
  background-size: 100%;
  height: 13px;
  width: 15px;
`

const ReviewReturnedLabelIcon = styled.div`
  background: url(${ReviewReturnedLabel}) no-repeat;
  background-size: 100%;
  height: 26px;
  width: 135px;
`

const InQualityReviewLabelIcon = styled.div`
  background: url(${InQualityReviewLabel}) no-repeat;
  background-size: 100%;
  height: 26px;
  width: 157px;
`

const PublishedLabelIcon = styled.div`
  background: url(${PublishedLabel}) no-repeat;
  background-size: 100%;
  height: 26px;
  width: 91px;
`

const DraftLabelIcon = styled.div`
  background: url(${DraftLabel}) no-repeat;
  background-size: 100%;
  height: 26px;
  width: 60px;
`

const AssignedIcon = styled.div`
  background: url(${Assigned}) no-repeat;
  background-size: 100%;
  height: 20px;
  width: 20px;
`

const CreateQuestIcon = styled.div`
  background: url(${CreateQuest}) no-repeat;
  background-repeat: no-repeat;
  background-size: 100%;
  height: 20px;
  width: 20px;
`

const UnassignedIcon = styled.div`
  background: url(${Unassigned}) no-repeat;
  background-size: 100%;
  height: 20px;
  width: 20px;
`

const CommentEditedIcon = styled.div`
  background: url(${CommentEdited}) no-repeat;
  background-size: 100%;
  height: 19px;
  width: 22px;
`

const CommentPostedIcon = styled.div`
  background: url(${CommentPosted}) no-repeat;
  background-size: 100%;
  height: 19px;
  width: 22px;
`

const EditIcon = styled.div`
  background: url(${Edit}) no-repeat;
  background-size: 100%;
  height: 12px;
  width: 12px;
`

const InternalApprovedIcon = styled.div`
  background: url(${InternalApproved}) no-repeat;
  background-size: 100%;
  height: 20px;
  width: 19px;
`

const InternalRemovedIcon = styled.div`
  background: url(${InternalRemoved}) no-repeat;
  background-size: 100%;
  height: 19px;
  width: 19px;
`

const QualityApprovedIcon = styled.div`
  background: url(${QualityApproved}) no-repeat;
  background-size: 100%;
  height: 19px;
  width: 19px;
`

const QualityRejectedIcon = styled.div`
  background: url(${QualityRejected}) no-repeat;
  background-size: 100%;
  height: 19px;
  width: 19px;
`

const IconWrapper = styled.div`
  width: 22px;
  margin-right: 34px;
  display: flex;
  justify-content: center;
`

const DeleteIcon = styled.div`
  background: url(${Deleted}) no-repeat;
  background-size: 100%;
  height: 16px;
  width: 14px;
`

const ActivityAddIcon = styled.div`
  background: url(${ActivityAdd}) no-repeat;
  background-size: 100%;
  height: 12px;
  width: 11px;
`

const ActivitiesSortedIcon = styled.div`
  background: url(${ActivitiesSorted}) no-repeat;
  background-size: 100%;
  height: 14px;
  width: 13px;
`

const ExpandedHistoryEventContainer = styled.div`
  position: relative;
  border-top: 1px solid #dedfe0;

  li {
    background: inherit !important;
  }

  * {
    cursor: pointer;
  }

  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 100%;
    width: 0;
    height: 0;
    border-style: solid;
  }

  &:after {
    left: ${props => (props.comment ? '77px' : '24px')};
    top: -20px;
    border-color: ${props => `transparent transparent ${props.bg} transparent`};
    border-width: 10px;
  }

  &:before {
    left: ${props => (props.comment ? '76px' : '23px')};
    top: -22px;
    border-color: transparent transparent #dedfe0 transparent;
    border-width: 11px;
  }
`

export {
  CommentEditedIcon,
  CommentPostedIcon,
  EditIcon,
  InternalApprovedIcon,
  InternalRemovedIcon,
  QualityApprovedIcon,
  QualityRejectedIcon,
  AssignedIcon,
  UnassignedIcon,
  CreateQuestIcon,
  IconWrapper,
  ReviewReturnedLabelIcon,
  DraftLabelIcon,
  PublishedLabelIcon,
  InQualityReviewLabelIcon,
  ReviewCommentIcon,
  DeleteIcon,
  ActivityAddIcon,
  ActivitiesSortedIcon,
  ExpandedHistoryEventContainer
}



// WEBPACK FOOTER //
// ./src/components/quest/questhistory/_Styled.js